import React from 'react';
import { SelectComparator } from './SelectComparator';
import { ColorRangeValueBox, InputsWrapper } from '../../../atoms';
import { ColorRangeValue } from './ColorRangeValue';
import type { ComponentOrReferenceFormattingRule } from '@ardoq/data-model';
import type { FormattingContextState } from '../types';
import { FlexBox } from '@ardoq/layout';

import { isRuleVersionSupported } from '../../../utils';

type Props = {
  rule: ComponentOrReferenceFormattingRule;
  formattingContext: FormattingContextState;
  isSidebar?: boolean;
};

export function ColorRangeFormattingRuleBody({
  rule,
  formattingContext,
}: Props) {
  const { __id: ruleId, field } = rule;
  const { updateRule, ruleInfo } = formattingContext;
  const { comparators, fieldFormatting } = ruleInfo[ruleId] || {};
  const filter = field ? fieldFormatting?.[field] : null;

  const isRuleUnsupported = !isRuleVersionSupported(true, rule.version);

  return (
    <>
      <InputsWrapper $isDisabled={isRuleUnsupported}>
        <SelectComparator
          selectedComparator={rule.comparator}
          comparators={comparators || []}
          onValueChange={comparator => {
            updateRule(rule.__id, { comparator, value: null });
          }}
          isNewConditionalFormatting={true}
          filterType={filter?.filterType}
        />
      </InputsWrapper>
      <InputsWrapper $isDisabled={isRuleUnsupported}>
        <ColorRangeValueBox>
          <FlexBox padding={'small'} flex={1}>
            <ColorRangeValue
              rule={rule}
              formattingContext={formattingContext}
            />
          </FlexBox>
        </ColorRangeValueBox>
      </InputsWrapper>
    </>
  );
}
